import team from './team';
import services from './services';
import products from './products';
import blogs from './blogs';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink : {link: '/Menu', title: 'menu'},
        subLink: [],
    },
    {
        id: 4,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery"  },
            { id: 2, link: "/Reservation", title: "Reservation" },
            // { id: 3, link: "/Clients", title: "Clients" },
            // { id: 4, link: "/Login", title: "Login" },
            // { id: 5, link: "/Register", title: "Register" },
            // { id: 6, link: "/Forgot-Password", title: "Forgot Password" },
            // { id: 7, link: "/Change-Password", title: "Change Password" },
            // { id: 8, link: "/Profile", title: "Profile" },
            // { id: 9, link: "/Edit-Profile", title: "Edit Profile" },
            // { id: 10, link: "/Edit-Address", title: "Edit Address" },
        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },

    // {
    //     id: 6,
    //     mainLink : {link: '#', title: 'blog'},
    //     subLink: [
    //         {id: 1, link: '/Blog-grid', title: 'blog grid'},
    //         {id: 2, link: '/Blog-list', title: 'blog list'},
    //         {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
    //     ],
    // },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'table grid'},
            {id: 2, link: '/Shop-list', title: 'Item list'},
            // {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            // {id: 4, link: '/Wishlist', title: 'wishlist'},
            // {id: 5, link: '/Cart', title: 'cart'},
            // {id: 6, link: '/Checkout', title: 'checkout'},
            // {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;